import { API_ENDPOINTS, api } from "../apis/constants";
import { SectionResponse } from "../types/section";
import { cacheService } from "./cache.service";

interface GetSectionsOptions {
    forceFresh?: boolean;
    cacheTTL?: number;
}

class SectionService {
    private SECTIONS_CACHE_KEY = 'sections_data';
    private SECTION_DETAIL_CACHE_KEY_PREFIX = 'section_detail_';
    private SECTION_CACHE_TTL = 180; // 3 minutes in seconds

    async getSections(options: GetSectionsOptions = {}): Promise<SectionResponse[]> {
        return cacheService.get<SectionResponse[]>(
            this.SECTIONS_CACHE_KEY,
            async () => {
                try {
                    const response = await api.get<SectionResponse[]>(API_ENDPOINTS.SECTIONS.PUBLIC);
                    return response.data;
                } catch (error) {
                    console.error('Error fetching sections:', error);
                    throw error;
                }
            },
            {
                forceFresh: options.forceFresh,
                ttl: options.cacheTTL || this.SECTION_CACHE_TTL
            }
        );
    }

    async getSectionBySlug(slug: string, options: GetSectionsOptions = {}): Promise<SectionResponse> {
        const cacheKey = `${this.SECTION_DETAIL_CACHE_KEY_PREFIX}${slug}`;

        return cacheService.get<SectionResponse>(
            cacheKey,
            async () => {
                try {
                    const response = await api.get<SectionResponse>(`${API_ENDPOINTS.SECTIONS.PUBLIC}/${slug}`);
                    return response.data;
                } catch (error) {
                    console.error(`Error fetching section with slug ${slug}:`, error);
                    throw error;
                }
            },
            {
                forceFresh: options.forceFresh,
                ttl: options.cacheTTL || this.SECTION_CACHE_TTL
            }
        );
    }
}

export const sectionService = new SectionService();